import translationIT from './it/translations.json';
import faqIT from './it/faq.json';
import faqEN from './en/faq.json';
import translationEN from './en/translations.json';
import translationFR from './fr/translations.json';
import translationDE from './de/translations.json';

const lang = {
  it: {
    label: 'Italiano',
    lang: 'it-IT',
    translation: translationIT,
    faq: faqIT
  },
  en: {
    label: 'English',
    lang: 'en-EN',
    translation: translationEN,
    faq: faqEN
  },
  fr: {
    label: 'French',
    lang: 'fr-FR',
    translation: translationFR
  },
  de: {
    label: 'German',
    lang: 'de-DE',
    translation: translationDE
  }
};

export default lang;
